export class SvgIconLoad {
  public static readonly type = '[SvgIcon] Svg Icon Load';
  constructor(public svgPath: string) {}
}
